import { NotInterestedRounded } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';

export const DurationNotSupported = () => {
  return (
    <Stack
      height="100%"
      spacing={2}
      alignItems="center"
      justifyContent="center"
    >
      <NotInterestedRounded sx={{ color: 'text.secondary', fontSize: 48 }} />
      <Stack spacing={1} alignItems="center" justifyContent="center">
        <Typography color="text.secondary">
          Applied duration not supported.
        </Typography>
        <Typography color="text.secondary">
          Switch to default duration to view data
        </Typography>
      </Stack>
    </Stack>
  );
};
